import react, { useEffect, useState } from "react";
import { DataGrid, getGridStringOperators, } from "@mui/x-data-grid";
import { Select, Tab, Tabs, MenuItem, InputLabel, FormControl, Autocomplete, FormControlLabel, Paper } from "@mui/material";
import { Grid, Card, CardContent, Divider, } from "@mui/material";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import styled from "styled-components";
import { Typography, Button, Checkbox, Fab, IconButton, InputAdornment, TextField, Stack, Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import searchIcon from "../../icons/searchIcon.svg"
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import { TABS, ROLES } from "../../constants";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile && ` position: relative; `} `;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;
const TableContainer = styled.div`
// height: calc(
//   100vh - ${isMobile ? "56px - 20px - 82.23px" : "112px - 34px - 43.77px"}
// );
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%; 
  margin: 0 auto; 
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};
  ${isMobile &&
    `
    flex-direction: column;
  `}
`;
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
const TabsContainer = styled.div`
  ${isMobile &&
    `
    height: calc(100vh - 56px - 20px - 43.77px);
  `}
`;
export default function AccessManagement() {
    const label = { inputProps: { "aria-label": "Checkbox demo" } };
    const location = useLocation();
    const selectedTabProp1 = location.state?.selectedTabProp;
    const [loading, setLoading] = useState(false);
    const [rowCount, setRowCount] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
    const [hasSearched, setHasSearched] = useState(false);
    const [visibleEmployees, setVisibleEmployees] = useState([]);
    const [callApi, setCallApi] = useState(false);
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [modules, setModules] = useState([]);
    const [module, setModule] = useState("");
    const [roles, setRoles] = useState([]);
    const [role, setRole] = useState("");
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [selectedTab, setSelectedTab] = useState(selectedTabProp1 || TABS.REGISTERED);
    const [newUser, setNewUser] = useState("");
    const [newAllUsers, setNewAllUsers] = useState([]);
    const [permissions, setPermissions] = useState({
        is_add: "Yes",
        is_update: "Yes",
        is_delete: "Yes",
        is_download: "Yes",
        is_approve: "Yes",
    });

    useEffect(() => {
        fetchOrder();
        // setCallApi(true);
        // if (callApi) {
        //     fetchOrder()
        // }
    }, [paginationModel.page, paginationModel.pageSize, module, newUser]);


    useEffect(() => {
        setNewUser("");
        if (role == "") {
            const newUser1 = allUsers?.filter((us) => us?.role == "admin")
            setNewAllUsers(newUser1);
        }
        else {
            const filteredUsers = allUsers.filter((u) => u.role.toLowerCase() == 'admin');
            setNewAllUsers(filteredUsers);
        }
    }, [role])

    useEffect(() => {
        fetchRoles();
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers();
        }
        // if (userData?.role === 'rsm') {
        //     getUsers('rsm', userData?.id);
        // }
        // if (userData?.role === 'asm') {
        //     getUsers('asm', userData?.id);
        // }
    }, []);

    const fetchRoles = async () => {
        try {
            setLoading(true)
            let results = await window.Platform.database.fetchRoles();
            if (results?.status) {
                setLoading(false);
                window.NotificationUtils.showError(results?.message || "Something went wrong");
            }
            else {
                let filteredModules = results?.moduleData?.results.filter((ele) => ele.status == 1);
                setModules(filteredModules || []);
console.log("Dsadsadasdadsada")

                const rolesExcludingAdmin = results?.data.filter((role) => role.roleName.toLowerCase() !== 'se');
                
                console.log(rolesExcludingAdmin)
                setRoles(rolesExcludingAdmin.filter((ele)=>ele.roleName=='admin'))
            }
        }
        catch (err) {
            console.log(err);
            setLoading(false)
        }
    }

    const handleSubmitPermissions = async () => {
        setLoading(true);
        try {
            const payload = {
                moduleId: module,
                role: role,
                userId: newUser,
                permissions: permissions,
            };
            let results = await window.Platform.database.createAccessModule(payload);

            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
            }
            else {
                window.NotificationUtils.showSuccess(results?.message || "Submit SuccessFully");
                fetchOrder();
                setModule("");
                setRole("");
                setNewUser("");
                setPermissions({
                    is_add: "Yes",
                    is_update: "Yes",
                    is_delete: "Yes",
                    is_download: "Yes",
                    is_approve: "Yes",
                });
            }
        } catch (error) {
            window.NotificationUtils.showError("Error Fetching Data");
            setLoading(false);
            console.log(error);
        }
        finally {
            setLoading(false);
        }

    };

    const fetchOrder = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                // ownerName: rm,
                // rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                // asm: userData?.role == 'asm' ? userData?.id : asm,
                userId: newUser,
                moduleId: module
            }
            // let results = await window.Platform.database.getAccessModules(data);
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setRowCount(results.data1)
                setVisibleEmployees(jsonArrayWithId);
                const p = jsonArrayWithId[0];
                setPermissions({
                    is_add: p.is_add === "Yes" ? "Yes" : "No",
                    is_update: p.is_update === "Yes" ? "Yes" : "No",
                    is_delete: p.is_delete === "Yes" ? "Yes" : "No",
                    is_download: p.is_download === "Yes" ? "Yes" : "No",
                    is_approve: p.is_approve === "Yes" ? "Yes" : "No",
                });
            }
        } catch (error) {
            console.error(error);
            // window.NotificationUtils.showError("No Data Found");
        }
        finally {
            setLoading(false)
        }
    }

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        if (results?.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false);
            return;
        }
        else {
            if (role == "") {
                const newUser1 = results?.data?.filter((us) => us?.role == "admin")
               
                setNewAllUsers(newUser1);
            }
            else {
                const filteredUsers = results?.data.filter((u) => u.role.toLowerCase() =='admin');
                setNewAllUsers(filteredUsers);
            }
            setAllUsers(results?.data)
            setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
            setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
            setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
            setLoading(false);
        }
    }

    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }
    }

    const handleTabChange = async (value, keepSelected = false) => {
        setVisibleEmployees([]);
        setSelectedTab(value);
    };

    const renderTabContent = () => {
        return (<>
            <div className="d-flex justify-content-end align-items-center  py-2">
                <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
                <Select
                    value={paginationModel.pageSize}
                    variant="outlined"
                    size="small"
                    onChange={(e) => { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                    sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
                >
                    {[10, 20, 30, 50, 100].map((role) => (
                        <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                    ))}
                </Select>
            </div>
            <DataGridContainer
                style={{ height: !visibleEmployees.length ? "200px" : "auto" }}
            >
                <DataGrid
                    className="payrollGrid"
                    density="compact"
                    rows={visibleEmployees || []}
                    columns={schoolColumns()}
                    sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
                    disableSelectionOnClick
                    disableRowSelectionOnClick
                    rowHeight={60}
                    pageSizeOptions={[10]}
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                />
            </DataGridContainer>
        </>
        );
    };

    const schoolColumns = () => {
        const stringOperators = getGridStringOperators().filter((op) =>
            ["contains"].includes(op.value)
        );
        let result = [
            {
                field: "userId",
                headerName: "User Name",
                minWidth: 200,
                valueGetter: (params) => {
                    let name = params.row?.user_name;
                    return name || "N/A";
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row?.user_name || "N/A";

                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "moduleName",
                headerName: "Module Name",
                minWidth: 300,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.module_name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {params.row.module_name || "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "Add",
                headerName: "Add",
                minWidth: 80,
                valueGetter: (params) => {
                    let name = params.row?.is_add;
                    return name || "N/A";
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row?.is_add || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "update",
                headerName: "Update",
                minWidth: 80,
                valueGetter: (params) => {
                    let name = params.row.is_update;
                    return name || "N/A";
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row.is_update || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "delete",
                headerName: "Delete",
                minWidth: 80,
                valueGetter: (params) => {
                    let name = params.row.is_delete;
                    return name || "N/A";
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row.is_delete || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "downlaod",
                headerName: "Download",
                minWidth: 130,
                valueGetter: (params) => {
                    let name = params.row.is_download;
                    return name || "N/A";
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row.is_download || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "approveRej",
                headerName: "Approve / Reject",
                minWidth: 180,
                valueGetter: (params) => {
                    let name = params.row.is_approve;
                    return name || "N/A";
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row.is_approve || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            }
        ].filter(Boolean);
        return result;
    };

    return (
        <>
            {loading && <OpaqueLoading />}
            <StaffEditorPageContainer>
                <HeaderContainer>
                    {/* <Box sx={{ mt: 1, width: "100%" }}>

                        <Paper elevation={3}
                            sx={{
                                p: 2,
                                mb: 2,
                                width: '100%',        // takes full width of parent
                                // maxWidth: '1000px',   // optional: control max width
                                mx: 'auto',
                                backgroundColor: "#ebf0fa"          // center it horizontally
                            }}>
                            <div className="container-fluid">
                                <div className="row mb-2 align-items-end">
                                    {userData?.role.includes('admin') && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                            <Select label="Select HO" value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    {userData?.role != 'asm' && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                            <Select label="Select ARM" value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                                            <Select label="Select RM" value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                                {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setCallApi(true); fetchOrder() }}>
                                            Find
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Paper>
                    </Box> */}
                    <Box sx={{ mt: 1, width: "100%" }}>
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <FormControl fullWidth>
                                        <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Module:</InputLabel>
                                        <Select label="Select Module" value={module} variant="outlined" onChange={(e) => { setModule(e.target.value); }} sx={{ width: '100%', fontSize: 14 }}>
                                            <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                            {modules.map((role, ind) => (<MenuItem key={ind} value={role.moduleId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.moduleName}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4">
                                    <FormControl fullWidth>
                                        <InputLabel sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>
                                            Select Role
                                        </InputLabel>
                                        <Select
                                            label="Select Role"
                                            fullWidth
                                            sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}
                                            value={role}
                                            onChange={(e) => setRole(e.target.value)}
                                        >
                                            {/* <MenuItem value="" sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>All</MenuItem> */}
                                            {roles.map((role) => (
                                                <MenuItem key={role.roleName} value={role.roleName} sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>
                                                    {role.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4">
                                    <Autocomplete
                                        options={newAllUsers}
                                        getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                                        value={allUsers.find((role) => role.id === newUser) || null}
                                        onChange={(event, value) => {
                                            setNewUser(value ? value.id : "");
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                label="Select User"
                                                {...params}
                                                placeholder="Select User"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    style: { color: "black", fontWeight: 500 },
                                                }}
                                                InputLabelProps={{
                                                    style: { color: "black", fontWeight: 500 },
                                                }}
                                            />
                                        )}
                                        slotProps={{
                                            paper: {
                                                sx: { color: "black" }
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        sx={{ width: '100%', fontSize: 14, color: "black" }}
                                    />
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-md-2 d-flex align-items-center" sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}>
                                    <FormControlLabel
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                color: "#000",         // DARK BLACK LABEL
                                                fontSize: "14px",
                                                fontWeight: "500",
                                            },
                                        }}
                                        control={
                                            <Checkbox
                                                checked={permissions.is_add === "Yes"}
                                                onChange={(e) =>
                                                    setPermissions({
                                                        ...permissions,
                                                        is_add: e.target.checked ? "Yes" : "No",
                                                    })
                                                }
                                            />
                                        }
                                        label="Add"
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <FormControlLabel
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                color: "#000",         // DARK BLACK LABEL
                                                fontSize: "14px",
                                                fontWeight: "500",
                                            },
                                        }}
                                        control={
                                            <Checkbox
                                                checked={permissions.is_update === "Yes"}
                                                onChange={(e) =>
                                                    setPermissions({
                                                        ...permissions,
                                                        is_update: e.target.checked ? "Yes" : "No",
                                                    })
                                                }
                                            />
                                        }
                                        label="Update"
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-center">

                                    <FormControlLabel
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                color: "#000",         // DARK BLACK LABEL
                                                fontSize: "14px",
                                                fontWeight: "500",
                                            },
                                        }}
                                        control={
                                            <Checkbox
                                                checked={permissions.is_delete === "Yes"}
                                                onChange={(e) =>
                                                    setPermissions({
                                                        ...permissions,
                                                        is_delete: e.target.checked ? "Yes" : "No",
                                                    })
                                                }
                                            />
                                        }
                                        label="Delete"
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <FormControlLabel
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                color: "#000",         // DARK BLACK LABEL
                                                fontSize: "14px",
                                                fontWeight: "500",
                                            },
                                        }}
                                        control={
                                            <Checkbox
                                                checked={permissions.is_download === "Yes"}
                                                onChange={(e) =>
                                                    setPermissions({
                                                        ...permissions,
                                                        is_download: e.target.checked ? "Yes" : "No",
                                                    })
                                                }
                                            />
                                        }
                                        label="Download"
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <FormControlLabel
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                color: "#000",         // DARK BLACK LABEL
                                                fontSize: "14px",
                                                fontWeight: "500",
                                            },
                                        }}
                                        control={
                                            <Checkbox
                                                checked={permissions.is_approve === "Yes"}
                                                onChange={(e) =>
                                                    setPermissions({
                                                        ...permissions,
                                                        is_approve: e.target.checked ? "Yes" : "No",
                                                    })
                                                }
                                            />
                                        }
                                        label="Approve / Reject"
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <Button
                                        // disabled={(module == "" || newUser == "") || permissions.is_add == "No" && permissions.is_update == "No" && permissions.is_delete == "No" && permissions.is_download == "No" && permissions.is_approve == "No"}
                                        disabled={
                                            newUser === "" ||
                                            module === "" 
                                        }
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleSubmitPermissions}
                                    >
                                        Submit
                                    </Button>
                                    {/* <span style={{color:"red", fontSize:"11px"}}>Must Be Select Module And User</span> */}
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-md-3">
                                    <Button
                                        // disabled={(module == "" || newUser == "") || permissions.is_add == "No" && permissions.is_update == "No" && permissions.is_delete == "No" && permissions.is_download == "No" && permissions.is_approve == "No"}
                                        disabled={
                                            newUser === "" ||
                                            module === "" ||
                                            (
                                                permissions.is_add === "No" &&
                                                permissions.is_update === "No" &&
                                                permissions.is_delete === "No" &&
                                                permissions.is_download === "No" &&
                                                permissions.is_approve === "No"
                                            )
                                        }
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleSubmitPermissions}
                                    >
                                        Submit Permissions
                                    </Button>
                                    <span style={{color:"red"}}>Must Be Select Module And User</span>
                                </div>
                            </div> */}
                        </div>

                    </Box>
                </HeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        {/* <StyledTabs
                            variant="fullWidth"
                            value={selectedTab}
                            onChange={(event, value) => handleTabChange(value)}
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab label="Access Management" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} />
                        </StyledTabs> */}
                        {loading && <OpaqueLoading />}
                        {renderTabContent()}
                    </TabsContainer>
                </TableContainer>
            </StaffEditorPageContainer>
        </>
    );
}
